// flow weak

import React, {
  Component
}                         from 'react';
import PropTypes          from 'prop-types';
import { appConfig } from '../../../config/appConfig';
import {
  Row,
  Col,
  Checkbox,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Alert
}                     from 'react-bootstrap';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
import { createBrowserHistory } from 'history';
import { withRouter, Link } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

import isEmpty from 'lodash.isempty';
import Pagination from 'react-paginating';

import '../dashboard/dashboard.scss';
import CountryStateCity from '../../../components/countryStateCity/CountryStateCity';
import { getAllCategory } from '../../../redux/actions/dealActions';
import { partnerPermission, becomePartner, getSiteCity } from '../../../redux/actions/frontActions';
import { get_becomePartner_details } from '../../../redux/actions/termsPolicyAndContactActions';
import logo from '../../../img/ddb-logo.png';

import { Notification } from '../../../components/notifications';

import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import NumberFormat from 'react-number-format';
import Cookies from 'universal-cookie';
import Recaptcha from 'react-recaptcha';
const cookies = new Cookies();

import languageConfig from '../../../config/languageConfig';

const history = createBrowserHistory();
let xCoordinate = {}, yCoordinate = {};
let isLoading = 'false';
class Partner extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      userName: '',
      businessName: '',
      websiteUrl: '',
      catList: '',
      hearAbout:'',
      contactName:'',
      email:'',
      phone:'',
      catID:'',
      country:'',
      state:'',
      city:'',
      cityID:'',
      onlineRetailor:'no',
      showAlert: false,
      disabled:'',
      hover: false,
      default_lang: 'en',
      //default_lang: (cookies.get('default_lang') ? cookies.get('default_lang') : 'en'),
      isVerified: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.verifyCallback = this.verifyCallback.bind(this);
    this.onloadCallback = this.onloadCallback.bind(this);
    this.expiredCallback = this.expiredCallback.bind(this);

    this.Clear=this.Clear.bind(this);
  }

  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem('data-id').value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem('data-id').value });    
  }

  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});

    if(`${e.target.name}Error` !== '') {
      this.setState({[`${e.target.name}Error`]:''});
    }
    this.setState({ disabled: false });
  }

  handleDismiss() {
    this.setState({ showAlert: false });
  }

  handleShow() {
    this.setState({ showAlert: true });
  }

  Clear() {
    this.setState({
      userName: '',
      businessName: '',
      websiteUrl: '',
      catList: '',
      hearAbout:'',
      contactName:'',
      email:'',
      phone:'',
      catID:'',
      country:'',
      state:'',
      city:'',
      cityID:'',
      onlineRetailor:'no',
      disabled: false,
      enabled: '',
      required: '',
      cityList:[],
      default_lang: 'en'
    });
  }

  componentDidMount() {
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    let disableSubscriptionPopup = (localStorage.getItem('disableSubscriptionPopup')) ? localStorage.getItem('disableSubscriptionPopup') : false;
    let accessibleCities = (localStorage.getItem('accessibleCities')) ? JSON.parse(localStorage.getItem('accessibleCities')) : [];

    // alert("Footer default_lang"+siteData.default_lang);
    // alert("Footer multi_lang"+siteData.multi_lang);
    // alert("Footer lang"+siteData.lang);

    if(siteData){
      if(siteData.default_city || siteData.multi_lang == "yes"){
        this.setState({
    multi_lang: siteData.multi_lang,
          lang: siteData.lang,
          default_lang: cookies.get('default_lang') ? cookies.get('default_lang') : siteData.default_lang,
  
        });
      }
    }
  }

  componentWillMount() {
    console.log('3Recaptcha loaded successfully!');
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData) {
      this.setState({multi_lang: siteData.multi_lang, lang: siteData.lang, default_lang: siteData.default_lang});
    }
    if(this.props.themeData) {
      if(this.props.themeData.button) {
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color
        });
      }
    }
    isLoading = 'true';
    this.props.partnerPermission('input-fields/become-partner');
    this.props.getAllCategory({ page: 0, lang: (siteData.default_lang) ? siteData.default_lang : '' });
    this.props.get_becomePartner_details();
    this.props.getSiteCity();
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.language) {
      if(this.state.default_lang !== nextProps.language) {
        this.setState({default_lang: nextProps.language});
        this.props.getAllCategory({ page: 0, lang: nextProps.language });
      }
    }
    if(nextProps.themeData) {
      if(nextProps.themeData.button) {
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color
        });
      }
    }
    if(this.props.permission !== nextProps.permission) {
      if(nextProps.permission) {
        if(nextProps.permission.data) {
          this.setState({
            enabled: nextProps.permission.data.enabled,
            required: nextProps.permission.data.required
          });
        }
        isLoading = 'false';
      }
    }
    if(this.props.partnerStatus != nextProps.partnerStatus) {
      if(nextProps.partnerStatus) {
        this.setState({showAlert:true});
        this.handleShow();
        this.setState({disabled:false});
        this.props.renderAlert('success', nextProps.partnerStatus.message);
        this.Clear();
        window.scrollTo(0, 0);
        this.props.partnerPermission('input-fields/become-partner');
      }
    }

    if(this.props.error != nextProps.error) {
      if(nextProps.error) {
        this.setState({showAlert:true});
        this.handleShow();
        this.setState({disabled:false});
        this.props.renderAlert('warning', nextProps.error);
        window.scrollTo(0, 0);
        this.props.partnerPermission('input-fields/become-partner');
      }
    }

    if(this.props.message !== nextProps.message) {
      this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType});
    }

    if(this.props.catList !== nextProps.catList) {
	    if (nextProps.catList) {
	      this.setState({ catList: nextProps.catList.data });
	    }
	  }

    if(this.props.cityList != nextProps.cityList) {
      if(nextProps.cityList) {
        this.setState({cityList: nextProps.cityList.data});
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
  }

  validate = () => { 
    let isError = false;
    const errors = {};
    xCoordinate = {};
    yCoordinate = {};

    if(!this.state.userName && this.state.required.userName == '0') {      
      isError = true;
      this.setState({userNameError:'red'});
    }

    if(!this.state.businessName && this.state.required.businessName == '0') {
      isError = true;
      this.setState({businessNameError:'red'});
    }

    if(!this.state.websiteUrl  && this.state.required.webAddress == '0') {
      isError = true;
      this.setState({websiteUrlError:'red'});
    }

    if(!this.state.hearAbout  && this.state.required.hearAbout == '0') {
      isError = true;
      this.setState({hearAboutError:'red'});
    }
    if(!this.state.cityID  && this.state.required.city == '0') {
      isError = true;
      this.setState({cityIDError:'red'});
    }

    if(!this.state.email  && this.state.required.email == '0') {
      isError = true;
      this.setState({emailError:'red'});
    }else if(this.state.email) {
      if(this.getValidationEmailState()) {
        isError = true;
        this.setState({emailError:'red'});
      }
    }

    if(!this.state.contactName  && this.state.required.contactName == '0') {
      this.setState({contactNameError:'red'});
    }


    if(!this.state.phone  && this.state.required.phone == '0') {
      isError = true;
      this.setState({phoneError:'red'});
    }


    if(!this.state.isVerified) {
      isError = true;
      this.setState({showAlert:true});
      this.props.renderAlert('Error', 'Please verify that you are human.');
      // window.scrollTo(0, 0);
      
      let x = window.scrollX + document.querySelector('#panelBodyMsg').getBoundingClientRect().left
      let y = window.scrollY + document.querySelector('#panelBodyMsg').getBoundingClientRect().top - 89
      xCoordinate['panelBodyMsg'] = x;
      yCoordinate['panelBodyMsg'] = y;
    
    }

    return isError;
  }

  getValidationEmailState() {
    if(this.state.email) {
      const length = this.state.email.length;
      if(length !==0) {
        let emailpattern= new RegExp(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if(!emailpattern.test(this.state.email)) {
          return 'error';
        }
      }
    }
    
    return null;
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const err = this.validate();
    if(!err) {
      this.setState({disabled:true});
      let formData = {
      	userName: this.state.userName,
        legalName: this.state.businessName,
        websiteUrl: this.state.websiteUrl,
        hearAbout:this.state.hearAbout,
        merchantName:this.state.contactName,
        catID:this.state.catID,
        email:this.state.email,
        phone:this.state.phone,
        country:this.state.country,
        state:this.state.stateAbbr,
        city:this.state.city,
        cityID:this.state.cityID,
        onlineRetailor:this.state.onlineRetailor,
        stateAbbr:this.state.stateAbbr,
        lang: this.state.default_lang
      };
      isLoading = 'true';
      this.props.becomePartner(formData);
    } else{
      let arr = Object.values(yCoordinate)
      let min = Math.min(...arr);
      let yCoordinateKey= '',yCoordinateValue, xCoordinateValue
      {Object.keys(yCoordinate).map((key) => {
        if(yCoordinate[key] === min && yCoordinateKey.length == 0){
          yCoordinateValue = yCoordinate[key]
          yCoordinateKey = key
        }
      })}
      if(yCoordinateKey.length > 0){
        xCoordinateValue = xCoordinate[yCoordinateKey]
      }
      window.scrollTo(xCoordinateValue, yCoordinateValue);
    }
    
  }

  onloadCallback() {
    console.log('Recaptcha loaded successfully!');
  }
 
  verifyCallback = (res) => {
    if(res) {
      this.setState({
        isVerified: true
      });
    }
  };
  
  expiredCallback() {
    this.setState({
      isVerified: false
    });
  }

  render() {
 	let categoryItems;
 	if (this.state.catList) {
      categoryItems = this.state.catList.map((category, index) => (
        <option key={category.catID} value={category.catID}>
          {category.catName}
        </option>
      ));
    }
    let enabled = (this.state.enabled) ? this.state.enabled : '';
    
    return(
      <div> 
        {isLoading == 'true' ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ''
        )}
        <form onSubmit={this.handleSubmit}>            
          <div className="container">
                
            <div className="panel margin-top">
              <header className="panel-heading">{languageConfig[this.state.default_lang].become_a_partner}</header>
              <div className="panel-body">
                <div id="panelBodyMsg">
                {this.state.showAlert && this.state.alertMessage !=='' &&        
                      <div className="col-lg-12">
                        <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                          <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                        </Alert>
                      </div>
                }
                </div>
                <Row>
                  <Col md={12} xs={12} className="text-center">
                    <div>                          
                      {ReactHtmlParser((this.state.default_lang == 'fr' ? this.props.french_becomePartnerDetails : this.props.becomePartnerDetails))}
                    </div>
                  </Col>
                  <Col md={12} xs={12}><hr/></Col>
                  <Col md={8} xs={12}>
                    <Row>
                      {(enabled.businessName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].business_name}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.businessName}
                                placeholder={languageConfig[this.state.default_lang].business_name}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.businessNameError}}
                                name="businessName"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.webAddress == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].web_address}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.websiteUrl}
                                placeholder={languageConfig[this.state.default_lang].web_address}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.websiteUrlError}}
                                name="websiteUrl"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }

                      {(enabled.hearAbout == '0') &&
                          <Col md={6} xs={12}>
                            <ControlLabel>{languageConfig[this.state.default_lang].did_you_hear_about}</ControlLabel>
                            <FormGroup>
                              <FormControl
                                type="text"
                                value={this.state.hearAbout}
                                placeholder={languageConfig[this.state.default_lang].did_you_hear_about}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.hearAboutError}}
                                name="hearAbout"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.contactName == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="contactName">
                                <ControlLabel>{languageConfig[this.state.default_lang].contact_name}</ControlLabel>
                                <FormControl
	                                type="text"
	                                value={this.state.contactName}
	                                placeholder={languageConfig[this.state.default_lang].contact_name}
	                                onChange={this.handleChange}
	                                style={{borderColor:this.state.contactNameError}}
	                                name="contactName"
	                                autoComplete="off"
	                             />
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                          
                        
                      {(enabled.email == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].email}</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.email}
                                placeholder={languageConfig[this.state.default_lang].email_address}
                                onChange={this.handleChange}
                                style={{borderColor:this.state.emailError}}
                                name="email"
                                autoComplete="off"
                              />
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.phone == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>{languageConfig[this.state.default_lang].phone}</ControlLabel>
                              <NumberFormat
		                        format="###-###-####"
		                        mask="_"
		                        className="form-control"
		                        name="phone"
		                        placeholder={languageConfig[this.state.default_lang].enter_phone_no}
		                        value={this.state.phone}
		                        onChange={this.handleChange}
		                        style={{borderColor:this.state.phoneError}}
		                      />
                            </FormGroup>
                          </Col>
                      }
                          
                        
                      {(enabled.catID == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="address2">
                                <ControlLabel>{languageConfig[this.state.default_lang].offer_have_mind}</ControlLabel>
                                <FormControl
		                          componentClass="select"
		                          placeholder="Select Category"
		                          name="catID"
		                          style={{ borderColor: this.state.catIDError }}
		                          value={this.state.catID}
		                          onChange={this.handleChange}
		                        >
		                          <option>{languageConfig[this.state.default_lang].select_category}</option>
		                          {categoryItems}
		                        </FormControl>
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                      {(enabled.onlineRetailor == '0') &&
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <FormGroup controlId="zip">
                                <ControlLabel>{languageConfig[this.state.default_lang].online_retailer}</ControlLabel>
                                <FormControl
		                          componentClass="select"
		                          name="onlineRetailor"
		                          style={{ borderColor: this.state.onlineRetailorError }}
		                          value={this.state.onlineRetailor}
		                          onChange={this.handleChange}
		                        >
		                          <option value="no">{languageConfig[this.state.default_lang].no}</option>
		                          <option value="yes">{languageConfig[this.state.default_lang].yes}</option>
		                        </FormControl>
                              </FormGroup>
                            </FormGroup>
                          </Col>
                      }
                    </Row>
                  </Col>
                  {(enabled.userName == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <ControlLabel>{languageConfig[this.state.default_lang].user_name}</ControlLabel>
                          <FormControl
                            type="text"
                            value={this.state.userName}
                            placeholder={languageConfig[this.state.default_lang].user_name}
                            onChange={this.handleChange}
                            style={{borderColor:this.state.userNameError}}
                            name="userName"
                            autoComplete="off"
                          />
                        </FormGroup>
                      </Col>
                  }
                  {(enabled.city == '0') &&
                      <Col md={4} xs={12}>
                        <FormGroup>
                          <ControlLabel>{languageConfig[this.state.default_lang].city_interest}</ControlLabel>
                          <FormControl style={{borderColor:this.state.cityIDError}} componentClass="select" name="cityID" value={this.state.cityID} placeholder="select" onChange={this.handleChange}>
                            <option value="">{languageConfig[this.state.default_lang].choose_region}</option>
                            {(this.state.cityList) &&
                              this.state.cityList.map((data, index) =>
                                (<optgroup key={'hcity'+index} label={data.country}>
                                  {(data.cities) &&
                                    data.cities.map((city, index) => 
                                      <option key={'hcityval'+index} value={city.cityID}>{city.title}</option>
                                    )
                                  }
                                </optgroup>)
                              )
                            }
                          </FormControl>
                        </FormGroup>
                      </Col>
                  }
                </Row>
                <Row>
                  <Col md={12} xs={12}>
                    <Recaptcha
                      sitekey={this.props.captchaKey ? this.props.captchaKey : appConfig.reCaptcha.siteKey}
                      render="explicit"
                      hl = {cookies.get('default_lang')}
                      verifyCallback={this.verifyCallback}
                      onloadCallback={this.onloadCallback}
                      expiredCallback={this.expiredCallback}
                    />
                  </Col>
                </Row>
                <Row>
  	                  <Col md={12} xs={12}>
  	                    <Button 
                      style={{backgroundColor: (this.state.hover && this.state.hoverID == 'partner') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                      data-id = {'partner'}
                      onMouseEnter={this.hoverOn} 
                      onMouseLeave={this.hoverOff} 
                      bsStyle="success" 
                      type="submit" 
                      disabled={this.state.disabled}>{languageConfig[this.state.default_lang].submit_business}</Button>
  	                  </Col>
  	                </Row>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}


Partner.propTypes = {
  becomePartner: PropTypes.func.isRequired,
  get_becomePartner_details: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  partnerStatus: state.frontReducer.partnerStatus,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  catList: state.categoryReducer.catData,
  permission: state.frontReducer.becomePermission,
  becomePartnerDetails: state.termsPolicyAndContactReducer.becomePartnerDetails,
  french_becomePartnerDetails: state.termsPolicyAndContactReducer.french_becomePartnerDetails,
  cityList: state.frontReducer.cityList
});


export default compose(
  connect(mapStateToProps, {becomePartner, get_becomePartner_details, renderAlert, clearAlert, getAllCategory, partnerPermission, getSiteCity})
)(Partner);



// WEBPACK FOOTER //
// ./src/app/views/frontend/Partner/Partner.js